import React, { FC } from "react";
import { CheckIcon } from "./InlineCheckbox";
import "../intakeFormSteps.scss";

interface CheckboxOptionCardProps {
  id: string;
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const CheckboxOptionCard: FC<CheckboxOptionCardProps> = ({
  id,
  label,
  description,
  checked,
  onChange,
}) => {
  return (
    <label
      className={`intake-form-step__option-card ${
        checked ? "intake-form-step__option-card--selected" : ""
      }`}
      htmlFor={id}
    >
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="intake-form-step__option-card__checkbox"
      />
      <div className="intake-form-step__option-card__content">
        <span className="intake-form-step__option-card__label">{label}</span>
        {description && (
          <span className="intake-form-step__option-card__description">
            {description}
          </span>
        )}
      </div>
      <div className="intake-form-step__option-card__indicator">
        {checked && <CheckIcon />}
      </div>
    </label>
  );
};

export default CheckboxOptionCard;
